import { useState, useEffect } from "react";

const useComparisonMode = (selectedFeatures) => {
    const [comparisonMode, setComparisonMode] = useState(false);

    useEffect(() => {
        if (selectedFeatures.length < 2 && comparisonMode) {
            setComparisonMode(false);
        }
    }, [selectedFeatures.length, comparisonMode]);

    return [comparisonMode, setComparisonMode];
};

export default useComparisonMode;
